import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    status: {
        download: '',
        downloadStatus: '',
        data: '',
        filter: {
            create: '',
            data: '',
            delete: '',
            names: ''
        },
        userTags: ''
    },
    selectedMonthRange: [],
    downloadStatus: '',
    downloadLink: '',
    summary: {
        minDate: null,
        maxDate: null,
        indexes: [],
        sizeOfData: 0
    },
    data: [],
    filterNames: [],
    userTags: [],
    savedFilter: {
        cols: [],
        rows: [],
        valueFilter: {}
    },
    filter: {
        cols: [],
        rows: [],
        valueFilter: {}
    },
    dataToken: null,
    downloadMode: false,
    costDownloadStatus: '',
    costDownloadLink: '',
    costDownloadDataToken: null
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
